module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mdigurp4-f5c995a6228ca2ece6bfdab9e1e66262.jpg";